export const Experiments: Record<string, number> = {
    LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP: 4944,
};

export const AllocationGroups = {
    A: 1,
    B: 2,
    C: 3,
    D: 4,
    E: 5,
} as const;
